<footer class="footer ">
    <div class="container-fluid">
        <div class="copyright pull-right">
            &copy;
            {{test | date: 'yyyy'}}, 
            <a href="#" target="_blank">GJ Web</a>
        </div>
    </div>
</footer>